<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Languages</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table
                        show-empty
                        striped
                        :items="languages"
                        :fields="fields"
                        >
                            <template v-slot:cell(title)="row">
                                {{row.value}}
                            </template>
                            <template v-slot:cell(longTitle)="row">
                                {{row.value}}
                            </template>
                            <template v-slot:cell(flag)="row">
                                <img class="img-profile rounded-circle" :src="row.item.flagImagePath">
                            </template>
                            <template v-slot:cell(translations)="row">
                                <button class="btn btn-primary" @click="redirectToTranslation(`/admin/languages/${row.item.title}/translations/`)">Translations</button>
                            </template>
                            <template v-slot:cell(modify)="row">
                                <button class="btn btn-warning" @click="modifyLanguage(row.item.title)">Modify</button>
                            </template>
                            <template v-slot:cell(delete)="row">
                                <button class="btn btn-danger" @click="deleteLanguage(row.item.title)">Delete</button>
                            </template>
                    </b-table>
                </div>
                <b-pagination-nav 
                    v-model="currentPage" 
                    :link-gen="linkGeneration" 
                    :number-of-pages="totalPages" 
                    use-router 
                    align="center"
                    :first-text="this.$t('PAGING_FIRST_PAGE')"
                    :last-text="this.$t('PAGING_LAST_PAGE')">
                </b-pagination-nav>
            </div>
        </div>
    </div>
</template>

<script>
import pagingMixin from './../../../mixins/pagingMixin';

export default {
    mixins: [ pagingMixin ],
    data () {
        return {
            languages : [],
            currentPage: null,
            totalLanguages: 0,
            totalPages: 1,
        }
    },
    computed: {
        fields(){ 
            return [
                { key: 'title', label: 'Language Code', sortable: true },
                { key: 'longTitle', label: 'Language'},
                { key: 'flag', label: 'Flag' },
                { key: 'translations', label: 'Translations', tdClass: 'fit' },
                { key: 'modify', label: 'Modify', tdClass: 'fit' },
                { key: 'delete', label: 'Delete', tdClass: 'fit' },
            ]
        },
    },
    methods : {
        getAllLanguages : function(){
            let self = this
            this.$http.get('/api/languages/list')
                .then( response => {
                    self.languages = response.data
                })
                .catch(error => {
                })
        },
        redirectToTranslation : function(route){
            this.$router.push(route)
        },
        modifyLanguage: function(langCode){
            this.$router.push(`/admin/languages/${langCode}/edit`)
        },
        deleteLanguage: function(langCode){
            let self = this
            let route = `/api/languages/delete/${langCode}`
            this.$http.delete(route)
            .then(response => {
                self.loadLanguages()
                self.getLanguagesCount()
                self.$store.dispatch('loadSystemLanguages')  
            })
            .catch(error => {
                console.log(error)
            })
        },
        getLanguagesCount: function() {
            this.$http.get('/api/languages/count')
            .then(response => {
                this.totalLanguages = response.data;
                this.totalPages = this.calculateNumberOfPages(this.totalLanguages);
            })
            .catch(error => {
                console.log(error)
            })
        },
        loadLanguages: function(){
            let self = this;
            this.$http.get('/api/languages/' + this.currentPage)
            .then(response => {
                if (self.languages.length == 0) {
                    self.getLanguagesCount();
                }
                self.languages = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        linkGeneration: function(pageNumber) {
            return {
                path: this.$route.path,
                query: { p: pageNumber }
            }
        }
    },
    created : function() {
       this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;
    },
    watch: {
        currentPage() {
            this.loadLanguages();
        }
    }
}
</script>

<style lang="scss" scoped>
    table {
        .rounded-circle {
            height : 2rem;
            width : 2rem;
        }
    }
</style>
